import { emailThreadContracts } from "./email-threads.contract";
import { outboundEmailContracts } from "./outbound-emails.contract";
import { inboundEmailContracts } from "./inbound-emails.contract";
import { emailRulesContracts } from "./email-rules.contract";
import { emailTemplatesContracts } from "./email-templates.contract";
import { pdfTemplatesContracts } from "./pdf-templates.contract";
import { templateBlocksContracts } from "./template-blocks.contract";
import { brandKitContracts } from "./brand-kit.contract";
import { contactsContracts } from "./contacts.contract";
import { organizationContactsContracts } from "./organization-contacts.contract";
import { notificationsContracts } from "./notifications.contract";

/**
 * Communications module contracts
 */
export const communicationsContracts = {
  emailThreads: emailThreadContracts,
  outboundEmails: outboundEmailContracts,
  inboundEmails: inboundEmailContracts,
  emailRules: emailRulesContracts,
  emailTemplates: emailTemplatesContracts,
  pdfTemplates: pdfTemplatesContracts,
  templateBlocks: templateBlocksContracts,
  brandKit: brandKitContracts,
  contacts: contactsContracts,
  organizationContacts: organizationContactsContracts,
  notifications: notificationsContracts,
} as const;

// Re-export types
export * from "./email-threads.contract";
export * from "./outbound-emails.contract";
export * from "./inbound-emails.contract";
export * from "./email-rules.contract";
export * from "./email-templates.contract";
export * from "./pdf-templates.contract";
export * from "./template-blocks.contract";
export * from "./brand-kit.contract";
export * from "./contacts.contract";
export * from "./organization-contacts.contract";
export * from "./notifications.contract";
